import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/** Probes the Gate 1 module boundary — returns { enabled, isAdmin } from the
 * backend's authoritative dual-mode check (platform Admin, or an entitled
 * business user). Never assumes state client-side. */
export function useSalesOutcomeStatus(shouldCheck) {
  const [enabled, setEnabled] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    if (!shouldCheck) {
      setEnabled(false);
      setIsAdmin(false);
      return;
    }
    let active = true;
    api
      .get("/sales-outcome")
      .then((res) => {
        if (active) {
          setEnabled(true);
          setIsAdmin(!!res.data?.is_admin);
        }
      })
      .catch(() => {
        if (active) {
          setEnabled(false);
          setIsAdmin(false);
        }
      });
    return () => {
      active = false;
    };
  }, [shouldCheck]);

  return { enabled, isAdmin };
}
